import styles from './styles.module.scss';
import { ExtendedReactElement } from '@/utils/types';

export const RoundedPlus = function ({
	className,
	isMoveNodeActive,
	onClick,
	style,
}: ExtendedReactElement<{
	isMoveNodeActive?: boolean;
}>) {
	return (
		<>
			<div className={`${isMoveNodeActive ? styles.moveToEdgeButton : styles.edgeButton} ${className}`} onClick={onClick} style={style}>
				<svg xmlns="http://www.w3.org/2000/svg">
					<g transform={`translate(15, 75)`}>
						<g transform="translate(-6, -5)">
							<line
								y2="10.084"
								fill="none"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
								transform="translate(5.042)"
								stroke="#6b7786"
							></line>
							<line
								x1="10.084"
								fill="none"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
								transform="translate(0 5.042)"
								stroke="#6b7786"
							></line>
						</g>
					</g>
				</svg>
			</div>
		</>
	);
};
